import JobZImage from "../../../../common/jobz-img";
import SectionEmployersCandidateSidebar from "../../sections/common/section-emp-can-sidebar";
import SectionShareProfile from "../../sections/common/section-share-profile";
import SectionOfficePhotos1 from "../../sections/common/section-office-photos1";
import SectionOfficeVideo1 from "../../sections/common/section-office-video1";
import SectionAvailableJobsList from "../../sections/employers/detail/section-available-jobs-list";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { loadScript } from "../../../../../globals/constants";
import { jobService } from "../../../../../services/job-service";

function EmployersDetail1Page() {
    const { id } = useParams();
    const [company, setCompany] = useState(null);
    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        if (!id) return;
        setLoading(true);
        jobService.company(id)
            .then((data) => {
                setCompany(data.company);
                setJobs(data.jobs || []);
            })
            .catch((err) => setError(err.message || "Failed to load company profile"))
            .finally(() => setLoading(false));
    }, [id]);

    useEffect(()=>{
        loadScript("js/custom.js")
    })

    if (loading) return <div className="p-a50 text-center">Loading company profile...</div>;
    if (error || !company) return <div className="p-a50 text-center text-danger">{error || "Company not found"}</div>;

    return (
        <>
            <div className="section-full  p-t120 p-b90 bg-white">
                <div className="container">
                    <div className="section-content">
                        <div className="row d-flex justify-content-center">
                            <div className="col-lg-8 col-md-12">
                                {/* Candidate detail START */}
                                <div className="cabdidate-de-info">
                                    <div className="twm-employer-self-wrap">
                                        <div className="twm-employer-self-info">
                                            <div className="twm-employer-self-top">
                                                <div className="twm-media-bg">
                                                    <JobZImage src={company.banner_url || "images/employer-bg.jpg"} alt={company.name} />
                                                </div>
                                                <div className="twm-mid-content">
                                                    <div className="twm-media">
                                                        <JobZImage src={company.logo_url || "images/jobs-company/pic1.jpg"} alt={company.name} />
                                                    </div>
                                                    <h4 className="twm-job-title">{company.name}</h4>
                                                    {company.location && <p className="twm-employer-address"><i className="feather-map-pin" />{company.location}</p>}
                                                    {company.website && <a href={company.website} target="_blank" rel="noreferrer" className="twm-employer-websites site-text-primary">{company.website}</a>}
                                                    <div className="twm-employer-self-bottom">
                                                        <a href="#Review" className="site-button outline-primary">Add Review</a>
                                                        <a href="https://www.linkedin.com/" className="site-button" target="_blank" rel="noreferrer">Follow Us</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <h4 className="twm-s-title">About Company</h4>
                                    <p style={{ whitespace: "pre-line" }}>{company.description || "No description provided."}</p>
                                    
                                    <SectionShareProfile />
                                    
                                    <div className="twm-two-part-section">
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6">
                                                <SectionOfficePhotos1 />
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <SectionOfficeVideo1 />
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <SectionAvailableJobsList jobs={jobs} />
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-12 rightSidebar">
                                <SectionEmployersCandidateSidebar type="1" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EmployersDetail1Page;